import { paymentMode, realPayEnabled } from "./config";

const CHANNELS = {
    MOCK_WECHAT: {
        label: "模拟微信支付",
        description: "测试支付，可选择支付结果",
    },
    MOCK_ALIPAY: {
        label: "模拟支付宝支付",
        description: "测试支付，可选择支付结果",
    },
    ALIPAY: {
        label: "支付宝支付",
        description: "跳转到支付宝沙箱环境完成支付",
    },
};

function getAvailableChannels() {
    if (paymentMode === "mini") {
        return ["MOCK_WECHAT"];
    }

    return realPayEnabled
        ? ["MOCK_WECHAT", "MOCK_ALIPAY", "ALIPAY"]
        : ["MOCK_WECHAT", "MOCK_ALIPAY"];
}

function isChannelAvailable(channel) {
    return getAvailableChannels().includes(channel);
}

function getDefaultChannel() {
    return getAvailableChannels()[0];
}

export default {
    getAvailableChannels,
    isChannelAvailable,
    getDefaultChannel,
    CHANNELS,
};
